import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./padLess03.png"

const _03mm未満のパッド = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { padLess03: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="0.3mm未満のパッド" helpURL={HELP_LINKS["0.3mm未満のパッド"]} src={img}>
      <RadioGroup name={FIELD_NAMES["0.3mm未満のパッド"]} selectedValue={values.padLess03} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["0.3mm未満のパッド"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["0.3mm未満のパッド"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.padLess03} />
    </OneClickField>
  )
}

export default _03mm未満のパッド
